import { PropsWithChildren } from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { XSvg } from "@components/index";

export const Modal = ({
  show,
  noPaddings,
  className,
  onClose,
  children,
}: {
  show: boolean;
  noPaddings?: boolean;
  className?: string;
  onClose: () => void;
} & PropsWithChildren) =>
  show && (
    <div className="fixed inset-0 z-10 flex items-center justify-center bg-black-54 p-4">
      <div
        className={twMerge(
          clsx(
            "w-full max-w-xl rounded-lg bg-white-100",
            !noPaddings && "p-4 md:p-8",
            className,
          ),
        )}
      >
        <div className="flex h-0 justify-end">
          <button type="button" className="z-10" onClick={onClose}>
            <XSvg />
          </button>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
